import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M9 10V16H15V10H19L12 3L5 10H9ZM12 5.8L14.2 8H13V14H11V8H9.8L12 5.8ZM19 18H5V20H19V18Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "UploadOutline"
);
